export default "__VITE_ASSET__otSrC2B5__"